//#region Imports

import { drawBox, drawRectangle } from "../draw/draw";
import AuxiliaryViewer from "./controls/AuxiliaryViewer.vue";
import {
  getAnnotationData,
  getAnnotationGeometry,
  drawAnnotations,
} from "./annotation";
import { runSmoothing } from "./smoothing";
import {
  Apps,
  get3dSlicePoints,
  focusDicomsTo3dPoint,
  updateNervePoints,
  DicomBox,
} from "./DicomManager";
import { updateNerveFromPoints } from "./DicomNerves";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";

//#endregion

//#region Fields

const sceneBackgroundColor = "#77a7fd";

let viewerInitialized = false;
let axViewer;
let defaultAxBox = null;
let defaultAxZoom = null;
let vueAppModels = [];
let dicomApp = null;
let childApp = null;
let auxilaryViewer = null;
let auxiliaryContainer = null;
let auxiliaryRaycaster = null;

let slicesVisible = false;
let frameMesh0 = null;
let frameMesh1 = null;

let phongMaterial = new THREE.MeshPhongMaterial({
  color: 0xeaeff2,
  flatShading: false,
  specular: 0x050505,
  shininess: 100,
  side: 2,
});

const defNervePointColor = 0x00ff00;
const defNervePointSize = 1.5;
let nervePointMeshes = [];
let highlightPointMesh = null;
let clickPointMesh = null;

let nervePointMenu = null;
let nervePointFocusBtn = null;
let nervePointRemoveBtn = null;

//#endregion

//#region Methods

function switchAuxiliaryView(app) {
  if (app.is3D) {
    childApp = app;
    showAuxiliaryViewer(app);
  }
}

function showAuxiliaryViewer(app) {
  dicomApp = app.parentApp;

  let annotation = dicomApp.focusedAnnotation;
  if (!annotation) {
    annotation = dicomApp.editedAnnotation;
  }
  dicomApp.selectedAnnotation = annotation;

  let containerId = app.auxiliaryId;
  let container = document.getElementById(containerId);

  if (!viewerInitialized) {
    // dicomApp.childApps[0]
    Apps[0].addEventListener("positionchange", () => {
      update3DSlices(slicesVisible);
    });
    Apps[2].addEventListener("positionchange", () => {
      update3DSlices(slicesVisible);
    });
    Apps[0].childApps[1].addEventListener("positionchange", () => {
      update3DSlices(slicesVisible);
    });

    const viewerInstance = (auxilaryViewer = new Vue({
      ...AuxiliaryViewer,
      propsData: {
        app: dicomApp,
      },
    }));
    const vueContainer = document.createElement("div");
    container.appendChild(vueContainer);
    viewerInstance.$mount(vueContainer);
    auxiliaryContainer = container.children[1];
    viewerInitialized = true;
  } else {
    if (auxilaryViewer) auxilaryViewer.app = dicomApp;
    container.appendChild(auxiliaryContainer);
  }

  if (axViewer) {
    // axViewer.do_resize();
    focusAuxilaryModel();
  }
}

function initAuxilaryStlViewer(aviewer, app) {
  auxilaryViewer = aviewer;
  console.log("initAuxilaryStlViewer");

  vueApp.allTeeth
    .concat(vueApp.bones)
    .concat(vueApp.nerves)
    .forEach((item) => {
      let mesh = viewer.get_model_mesh(item.id);
      if (mesh && mesh.geometry && mesh.geometry.boundingBox) {
        let tmesh = new THREE.Mesh(
          mesh.geometry.clone(),
          phongMaterial.clone(),
        );
        tmesh.geometry.translate(
          mesh.position.x,
          mesh.position.y,
          mesh.position.z,
        );
        let color = vueApp.getActualColor(item);
        const model = {
          name: item.filename,
          mesh: tmesh,
          color: color,
          rootModel: item,
          opacity: 0.01,
          position: mesh.position,
          isBone: item.isBone,
        };
        vueAppModels.push(model);
      } else {
        console.log("invalid tooth", item);
      }
    });

  axViewer = new StlViewer(document.getElementById(app.auxiliaryViewerId), {
    models: vueAppModels,
    load_three_files: "js/",
    controls: 1,
    model_loaded_callback: stlModelLoaded,
    // zoom: -1,
  });
  axViewer.scene.background = new THREE.Color(sceneBackgroundColor);
  axViewer.controls.zoomSpeed = 2.1;
  axViewer.controls.keysEnabled = false;

  setTimeout(function () {
    auxilaryStlAllLoaded();
    attachEvents(auxiliaryContainer);
  }, 100);
}

function auxilaryStlAllLoaded() {
  console.log("auxilaryStlAllLoaded");
  // axViewer.scene.add(new THREE.AxesHelper(80));
  axViewer.controls.screenSpacePanning = true;
  axViewer.renderer.outputEncoding = THREE.sRGBEncoding;
  let currentMin = { x: axViewer.minx, y: axViewer.miny, z: axViewer.minz };
  let currentMax = { x: axViewer.maxx, y: axViewer.maxy, z: axViewer.maxz };
  let currentBox = { min: currentMin, max: currentMax };
  defaultAxBox = convertToBox(currentBox);
  console.log("defaultAxBox", defaultAxBox);

  let padding = -10;
  let w = (defaultAxBox.size.x + padding) / 2;
  let h = (defaultAxBox.size.y + padding) / 2;
  let fovX = axViewer.camera.fov * axViewer.camera.aspect;
  let fovY = axViewer.camera.fov;
  let distanceX = w / Math.tan((Math.PI * fovX) / 360) + w;
  let distanceY = h / Math.tan((Math.PI * fovY) / 360) + w;
  defaultAxZoom = Math.max(distanceX, distanceY) + 20;

  vueAppModels.forEach((model) => {
    axViewer.set_opacity(model.id, 1);
    model.mesh.visible = false;
  });

  focusAuxilaryModel();

  // resetAxCamera();
}

function focusAuxilaryModel(newDicomApp) {
  if (newDicomApp) dicomApp = newDicomApp;

  if (dicomApp && axViewer) {
    let annotation = dicomApp.focusedAnnotation;
    if (!annotation) {
      annotation = dicomApp.editedAnnotation;
    }
    dicomApp.selectedAnnotation = annotation;

    vueAppModels.forEach((model) => {
      model.mesh.visible = false;
    });

    if (annotation) {
      let selectedModel = vueAppModels.find(
        (model) => model.rootModel == annotation.model,
      );
      // console.log("focusAuxilaryModel", selectedModel);
      if (selectedModel) {
        selectedModel.mesh.visible = true;
        focusViewToAxModel(selectedModel);

        if (annotation.changed) {
          updateAuixiliaryMesh(annotation);
        }
      } else {
        // let blob = getAnnotationData(annotation, dicomApp);
        let ageometry = getAnnotationGeometry(annotation, dicomApp);
        if (ageometry) {
          ageometry.computeBoundingBox();
          // ageometry.computeVertexNormals();
          // ageometry = new THREE.Geometry().fromBufferGeometry(ageometry);
          // geometry.mergeVertices();
          // geometry.computeVertexNormals();
          // geometry = new THREE.BufferGeometry().fromGeometry(geometry);
          // geometry.computeBoundingBox();
          let material = phongMaterial.clone();
          let color = annotation.color;
          material.color = new THREE.Color(color);
          let mesh = new THREE.Mesh(ageometry, material);
          mesh.justAdded = true;
          const model = {
            name: annotation.filename,
            mesh: mesh,
            // local_file: new File([blob], annotation.filename),
            color: color,
            rootModel: annotation.model,
            opacity: 1,
          };
          vueAppModels.push(model);
          axViewer.add_model(model);
          annotation.changed = false;
        }
      }

      update3dNervePoints(annotation);
      update3DSlices(slicesVisible);
      // resetAxCamera();
    }
  }
}

function stlModelLoaded(model_id) {
  let model = vueAppModels.find((model) => model.id == model_id);
  if (model) {
    // console.log("auxilary stlModelLoaded", model_id, tooth.name);
    if (!model.mesh) {
      model.mesh = axViewer.get_model_mesh(model.id);
    }
    let mesh = model.mesh;
    if (mesh && mesh.justAdded) {
      if (model.rootModel && model.rootModel.isNerve) {
        let box = mesh.geometry.baseBox;
        if (box) {
          mesh.position.set(box.center.x, box.center.y, box.center.z);
        }
        focusViewToAxModel(model);
      } else {
        let toothBox = offsetBox(mesh.geometry.boundingBox);
        let point = toothBox.center;
        if (!isNaN(point.x) && !isNaN(point.y) && !isNaN(point.z)) {
          mesh.justAdded = false;
          focusViewToAxModel(model);
        }
      }
    }
  }
}

function updateAuixiliaryMesh(annotation) {
  if (childApp && childApp.is3D && dicomApp && annotation) {
    annotation.changed = false;
    $(childApp.annotationSpinnerId).css({ display: "block" });
    console.log("updateAuixiliaryMesh", annotation.filename);

    setTimeout(async function () {
      let newGeometry = null;
      if (annotation.isNerve) {
        newGeometry = await updateNerveFromPoints(annotation);
        annotation.wasChanged = true;
      } else {
        newGeometry = getAnnotationGeometry(annotation, dicomApp);
      }

      if (newGeometry) {
        newGeometry.computeBoundingBox();
        newGeometry.computeVertexNormals();

        let selectedModel = vueAppModels.find(
          (model) => model.rootModel == annotation.model,
        );
        if (selectedModel) {
          let mesh = axViewer.get_model_mesh(selectedModel.id);
          if (mesh) {
            let oldGeometry = mesh.geometry;
            mesh.geometry = newGeometry;

            if (annotation.isNerve && newGeometry.baseBox) {
              let box = newGeometry.baseBox;
              mesh.position.set(box.center.x, box.center.y, box.center.z);

              let globalModel = vueApp.allItems.find(
                (x) => x == annotation.model,
              );
              let globalMesh = globalModel
                ? viewer.get_model_mesh(globalModel.id)
                : null;
              if (globalMesh) {
                globalMesh.geometry = newGeometry;
                globalMesh.position.set(
                  box.center.x,
                  box.center.y,
                  box.center.z,
                );
              }
              updateGlobalNerve();
              drawAnnotations(dicomApp, DicomBox);
            }

            mesh.visible = true;

            if (
              !oldGeometry.attributes ||
              !oldGeometry.attributes.position ||
              !oldGeometry.attributes.position.count ||
              mesh.justAdded
            ) {
              mesh.justAdded = false;
              focusViewToAxModel(selectedModel);
            }

            oldGeometry.dispose();
          }
        } else {
          let material = phongMaterial.clone();
          let color = annotation.color;
          material.color = new THREE.Color(color);
          let mesh = new THREE.Mesh(newGeometry, material);
          mesh.justAdded = true;
          if (annotation.isNerve && newGeometry.baseBox) {
            let box = newGeometry.baseBox;
            mesh.position.set(box.center.x, box.center.y, box.center.z);
          }

          const model = {
            name: annotation.filename,
            mesh: mesh,
            // local_file: new File([blob], annotation.filename),
            color: color,
            rootModel: annotation.model,
            opacity: 1,
          };
          vueAppModels.push(model);
          axViewer.add_model(model);
          annotation.changed = false;

          let globalModel = vueApp.allItems.find((x) => x == annotation.model);
          if (globalModel) {
            globalModel.stlModelLoaded = initNerve;
            let vmesh = new THREE.Mesh(newGeometry);
            let stlModel = {
              mesh: vmesh,
              color: globalModel.color,
            };
            stlModel.id = globalModel.id;
            viewer.add_model(stlModel);

            setTimeout(function () {
              updateGlobalNerve();
              drawAnnotations(dicomApp, DicomBox);
            }, 300);
          }
        }
      }

      $(childApp.annotationSpinnerId).css({ display: "none" });
    }, 50);
  }
}

function resetAxCamera() {
  let point = defaultAxBox.center;

  axViewer.camera.up.y = 1;
  axViewer.camera.up.x = 0;
  axViewer.camera.up.z = 0;
  axViewer.camera.position.x = point.x;
  axViewer.camera.position.y = point.y;
  axViewer.camera.position.z = defaultAxZoom;

  axViewer.camera.lookAt(point.x, point.y, point.z);
  axViewer.controls.target = new THREE.Vector3(point.x, point.y, point.z);

  // newGeometry.center();
  // let geometry = new THREE.Geometry().fromBufferGeometry(newGeometry);
  // geometry.mergeVertices();
  // geometry.computeVertexNormals();
  // geometry = new THREE.BufferGeometry().fromGeometry(geometry);
  // geometry.computeBoundingBox();
  // geometry.computeBoundingSphere();
  // geometry.attributes.position.needsUpdate = true;
  // mesh.material.needsUpdate = true;
  // mesh.updateMatrix();
  // let box = geometry.boundingBox;
  // box = offsetBox(box);
  // drawBox(box, 0xff0000, axViewer);
}

function focusViewToAxModel(model) {
  let mesh = model ? model.mesh : null;
  if (mesh && axViewer) {
    let toothBox = offsetBox(
      mesh.geometry.boundingBox,
      mesh.position.x,
      mesh.position.y,
      mesh.position.z,
    );
    // resetAxCamera();
    let point = toothBox.center;
    if (!isNaN(point.x) && !isNaN(point.y) && !isNaN(point.z)) {
      axViewer.camera.lookAt(point.x, point.y, point.z);
      axViewer.controls.target = new THREE.Vector3(point.x, point.y, point.z);
      axViewer.camera.position.z = model.isBone
        ? defaultAxZoom
        : defaultAxZoom / 3 + point.z;
    }
  }
}

function smoothSelectedAnnotation() {
  let annotation = dicomApp.focusedAnnotation;
  if (!annotation) {
    annotation = dicomApp.editedAnnotation;
  }
  if (annotation) {
    let factor = annotation.smoothFactor;
    console.log("smoothSelectedAnnotation", factor);
    let selectedModel = vueAppModels.find(
      (model) => model.rootModel == annotation.model,
    );
    if (selectedModel) {
      let mesh = axViewer.get_model_mesh(selectedModel.id);
      // let currentGeometry = mesh.geometry.clone().toIndexed();

      let newGeometry = getAnnotationGeometry(annotation, dicomApp);
      // runSmoothing(currentGeometry, 1);
      newGeometry.computeBoundingBox();

      // newGeometry.center();
      newGeometry.computeVertexNormals();

      let geometry = newGeometry;

      // let geometry = new THREE.Geometry().fromBufferGeometry(newGeometry);
      // geometry.mergeVertices();
      // geometry.computeVertexNormals();
      // geometry = new THREE.BufferGeometry().fromGeometry(geometry);
      // geometry.computeBoundingBox();

      mesh.geometry.dispose();
      mesh.geometry = geometry;

      annotation.wasChanged = true;

      let rootModel = selectedModel.rootModel;
      // vueApp.allTeeth.find(
      //   (model) => model.name == annotation.filename
      // );
      if (rootModel) {
        mesh = viewer.get_model_mesh(rootModel.id);
        if (mesh && mesh.geometry) {
          let cgeometry = geometry.clone().center();
          mesh.geometry.dispose();
          mesh.geometry = cgeometry;
        }
      }
    }
  }
}

//#endregion

//#region Events

function attachEvents() {
  auxiliaryContainer.addEventListener("mousedown", onDocumentMouseDown, false);
  auxiliaryContainer.addEventListener("mousemove", onDocumentMouseMove, false);
  auxiliaryContainer.addEventListener("mouseup", onDocumentMouseUp, false);
  auxiliaryContainer.addEventListener("dblclick", onDocumentDblClick, false);

  nervePointMenu = document.getElementById("annotation-nerve-point-menu");
  auxiliaryContainer.appendChild(nervePointMenu);

  nervePointFocusBtn = document.getElementById(
    "annotation-nerve-focus-point-btn",
  );
  nervePointFocusBtn.addEventListener("click", () => focusToNervePoint());

  nervePointRemoveBtn = document.getElementById(
    "annotation-nerve-remove-point-btn",
  );
  nervePointRemoveBtn.addEventListener("click", () => removeNervePoint());
}

function updateRaycaster(event) {
  try {
    let direction = getMouse3dDirection(event);
    if (!direction || !axViewer.camera.position) return;

    if (
      !auxiliaryRaycaster ||
      !auxiliaryRaycaster.ray ||
      !auxiliaryRaycaster.ray.direction ||
      !auxiliaryRaycaster.ray.origin
    ) {
      auxiliaryRaycaster = new THREE.Raycaster(
        axViewer.camera.position, // origin
        direction,
        0.1,
        100000,
      );
    } else {
      auxiliaryRaycaster.set(axViewer.camera.position, direction);
    }
  } catch (error) {
    // console.error("updateRaycaster", error);
  }
}

function getMouse3dDirection(event) {
  var direction = null;
  if (event && event.pageX && event.pageY) {
    var overlayRect = auxiliaryContainer.getBoundingClientRect();
    var x = event.pageX - overlayRect.left;
    var y = event.pageY - overlayRect.top;
    direction = new THREE.Vector3(
      (x / overlayRect.width) * 2 - 1,
      -(y / overlayRect.height) * 2 + 1,
      0.5,
    );
    direction.unproject(axViewer.camera);
    direction.sub(axViewer.camera.position);
    direction.normalize();
  }

  return direction;
}

function onDocumentMouseDown(event) {}

function onDocumentMouseMove(event) {
  if (!dicomApp) return;

  let annotation = dicomApp.focusedAnnotation;
  if (!annotation) {
    annotation = dicomApp.editedAnnotation;
  }
  if (annotation && annotation.isNerve && nervePointMeshes) {
    let pointMesh = getIntersectedNervePointMesh(event);
    if (pointMesh) {
      if (pointMesh != highlightPointMesh) {
        pointMesh.material.opacity = 1;
        highlightPointMesh = pointMesh;
      }
    } else if (highlightPointMesh) {
      highlightPointMesh.material.opacity = 0.7;
      highlightPointMesh = null;
    }
  }
}

function onDocumentMouseUp(event) {}

function onDocumentDblClick(event) {
  if (!dicomApp) return;

  let annotation = dicomApp.focusedAnnotation;
  if (!annotation) {
    annotation = dicomApp.editedAnnotation;
  }
  if (annotation && annotation.isNerve && nervePointMeshes) {
    let pointMesh = getIntersectedNervePointMesh(event);
    if (pointMesh) {
      clickPointMesh = pointMesh;

      nervePointMenu.style.display = "initial";
      nervePointMenu.style.left = event.offsetX + 1 + "px";
      nervePointMenu.style.top = event.offsetY + 1 + "px";
    }
  }
}

//#endregion

//#region Nerve

function initNerve(model_id) {
  let nerve = vueApp.getItemById(model_id);
  console.log("initNerve", model_id, nerve);
  if (nerve) {
    nerve.stlModelLoaded = null;
    let mesh = viewer.get_model_mesh(nerve.id);
    let box = mesh.geometry.baseBox;
    if (box) {
      mesh.position.set(box.center.x, box.center.y, box.center.z);
    }

    if (nerve.isSingle) {
      nerve.isDeleted = true;
      nerve.isVisible = false;
      mesh.visible = false;
    }
  }
}

function updateGlobalNerve() {
  let singleNerves = vueApp.nerves.filter((n) => n.isSingle);
  let meshes = [];
  for (const model of singleNerves) {
    let smesh = viewer.get_model_mesh(model.id);
    if (smesh.geometry) meshes.push(smesh);
  }
  let modelGeometry = null;
  // if (meshes.length == 1) {
  //   modelGeometry = meshes[0].geometry.clone();
  // }
  if (meshes.length > 0) {
    let geometries = [];
    meshes.forEach((b) => {
      b.updateMatrixWorld();
      let geometry = b.geometry.clone();
      if (geometry.index) geometry = geometry.toNonIndexed();
      geometry.applyMatrix4(b.matrixWorld);
      geometry.deleteAttribute("uv");
      geometry.deleteAttribute("color");
      geometry.attributes.position.gpuType = 1015;
      geometry.attributes.normal.gpuType = 1015;
      geometries.push(geometry);
    });

    modelGeometry = BufferGeometryUtils.mergeGeometries(geometries, true);
    modelGeometry.deleteAttribute("normal");
    modelGeometry = BufferGeometryUtils.mergeVertices(modelGeometry); // , 1
    modelGeometry.computeVertexNormals();
    modelGeometry.computeBoundingBox();

    modelGeometry.baseBox = offsetBox(modelGeometry.boundingBox);
    modelGeometry.center();
  }

  if (modelGeometry) {
    let globalModel = vueApp.nerves.find((n) => !n.isSingle);
    let globalMesh = viewer.get_model_mesh(globalModel.id);
    if (globalMesh && globalMesh.geometry) {
      let box = modelGeometry.baseBox;
      globalMesh.geometry = modelGeometry;
      globalMesh.position.set(box.center.x, box.center.y, box.center.z);
    } else {
      globalModel.stlModelLoaded = initNerve;
      globalMesh = new THREE.Mesh(modelGeometry);
      let stlModel = {
        mesh: globalMesh,
        color: globalModel.color,
      };
      stlModel.id = globalModel.id;
      viewer.add_model(stlModel);
      globalModel.isDeleted = false;
    }
  }
}

function update3dNervePoints(annotation) {
  if (axViewer) {
    for (const mesh of nervePointMeshes) {
      axViewer.scene.remove(mesh);
    }
    nervePointMeshes = [];

    if (annotation && annotation.isNerve) {
      annotation.allNervePoints = [annotation.startNervePoint]
        .concat(annotation.middleNervePoints)
        .concat(annotation.endNervePoint)
        .filter((p) => !!p);
      // let points = annotation.middleNervePoints
      //   ? [...annotation.middleNervePoints]
      //   : [];
      // if (annotation.startNervePoint) points.push(annotation.startNervePoint);
      // if (annotation.endNervePoint) points.push(annotation.endNervePoint);
      const center = new THREE.Vector3();
      for (const point of annotation.allNervePoints) {
        if (!point) continue;
        center.add(point);
        // let rpoint = new THREE.Vector3(
        //   point.x - defaultXOffset,
        //   point.y - defaultYOffset,
        //   point.z - defaultZOffset,
        // );
        let geometry = new THREE.SphereGeometry(defNervePointSize, 16, 16); // , 64, 32
        let mesh = new THREE.Mesh(
          geometry,
          new THREE.MeshPhongMaterial({
            color: defNervePointColor,
            flatShading: false,
            specular: 0x050505,
            shininess: 200,
            side: 2,
            transparent: true,
            opacity: 0.7,
          }),
        );
        mesh.tag = "nervePoint";
        mesh.annotation = annotation;
        mesh.point = point;

        point.mesh = mesh;

        mesh.position.set(point.x, point.y, point.z);
        axViewer.scene.add(mesh);
        nervePointMeshes.push(mesh);
      }

      let selectedModel = vueAppModels.find(
        (model) => model.rootModel == annotation.model,
      );
      if (!selectedModel && annotation.allNervePoints.length) {
        center.divideScalar(annotation.allNervePoints.length);
        axViewer.camera.lookAt(center.x, center.y, center.z);
        axViewer.controls.target = new THREE.Vector3(
          center.x,
          center.y,
          center.z,
        );
        axViewer.camera.position.z = defaultAxZoom / 3 + center.z;
      }
    }
  }
}

function getIntersectedNervePointMesh(event) {
  let intersectedMesh = null;

  try {
    updateRaycaster(event);
    let intersects = auxiliaryRaycaster.intersectObjects(nervePointMeshes);
    intersectedMesh = intersects.length > 0 ? intersects[0].object : null;
  } catch (error) {
    console.log("getIntersectedNervePointMesh", error);
  }

  return intersectedMesh;
}

function focusToNervePoint() {
  nervePointMenu.style.display = "none";
  if (clickPointMesh) {
    focusDicomsTo3dPoint(clickPointMesh.position, dicomApp.crossedApps, true);
    clickPointMesh = null;
  }
}

function removeNervePoint(pointMesh) {
  nervePointMenu.style.display = "none";

  if (pointMesh) clickPointMesh = pointMesh;

  if (clickPointMesh) {
    axViewer.scene.remove(clickPointMesh);
    let annotation = clickPointMesh.annotation;
    let point = clickPointMesh.point;
    if (annotation.startNervePoint == point) {
      annotation.startNervePoint = null;
    } else if (annotation.endNervePoint == point) {
      annotation.endNervePoint = null;
    } else if (annotation.middleNervePoints) {
      let index = annotation.middleNervePoints.indexOf(point);
      if (index > -1) {
        annotation.middleNervePoints.splice(index, 1);
      }
    }
    annotation.allNervePoints = [annotation.startNervePoint]
      .concat(annotation.middleNervePoints)
      .concat(annotation.endNervePoint)
      .filter((p) => !!p);

    clickPointMesh = null;

    updateNervePoints(dicomApp, annotation);
  }
}

//#endregion

//#region 3D Frames

function update3DSlices(visible) {
  slicesVisible = visible;
  hideSlices();
  if (slicesVisible) {
    let app0 = dicomApp; //.childApps[0];
    let app1 = dicomApp.childApps[1];
    let offset0 = (app0.current - 1) / app0.max;
    if (app0.index == 2) {
      offset0 = (app0.max - app0.current + 1) / app0.max;
    }
    frameMesh0 = drawRectangle(
      get3dSlicePoints(app0.index, offset0),
      app0.color,
      app0.vFrom,
      true,
      true,
      null,
      0.5,
      axViewer.scene,
    );
    if (app0.index != 2) {
      let offset1 = (app1.current - 1) / app1.max;
      frameMesh1 = drawRectangle(
        get3dSlicePoints(app1.index, offset1),
        app1.color,
        app1.vFrom,
        true,
        true,
        null,
        0.5,
        axViewer.scene,
      );
    }
  }
}

function hideSlices() {
  if (frameMesh0) {
    axViewer.scene.remove(frameMesh0);
    // frameMesh0.dispose();
    frameMesh0 = null;
  }
  if (frameMesh1) {
    axViewer.scene.remove(frameMesh1);
    // frameMesh1.dispose();
    frameMesh1 = null;
  }
}

//#endregion

//#region Export
export {
  axViewer,
  switchAuxiliaryView,
  initAuxilaryStlViewer,
  focusAuxilaryModel,
  updateAuixiliaryMesh,
  smoothSelectedAnnotation,
  update3DSlices,
  hideSlices,
  update3dNervePoints,
  removeNervePoint,
};
//#endregion
